import { ObligationRulesCategory } from '@commenda/prisma';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export interface GetFilingCategoriesResponse {
  categories: ObligationRulesCategory[];
}

export function useGetFilingCategories(
  country?: string,
  jurisdiction?: string,
  token?: string
) {
  const params = new URLSearchParams();
  if (country) params.append('country', country);
  if (jurisdiction) params.append('jurisdiction', jurisdiction);
  const queryString = params.toString();
  const url = country
    ? `content/filings/categories${queryString ? `?${queryString}` : ''}`
    : null;

  const {
    data,
    error,
    mutate,
  }: {
    data?: GetFilingCategoriesResponse;
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    url,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    mutate,
    isLoading: Boolean(url) && !data && !error,
  };
}
